// Google Ads tracking for cart page
document.addEventListener('DOMContentLoaded', function() {
  // Get cart data from the page - only from the main cart content
  const cartItems = document.querySelector('.cart__items[data-items-holder]')?.querySelectorAll('.cart-item') || [];
  const productMap = new Map(); // Use Map to store unique products with their quantities and prices
  
  // Extract product IDs and calculate total value
  cartItems.forEach(item => {
    const variantId = item.getAttribute('data-variant-id');
    if (variantId) {
      const price = parseFloat(item.getAttribute('data-cart-item-price'));
      const quantityElement = item.querySelector('[data-quantity-field]');
      
      if (price && quantityElement) {
        const quantity = parseInt(quantityElement.value);
        
        // If product already exists in map, update its quantity
        if (productMap.has(variantId)) {
          const existing = productMap.get(variantId);
          productMap.set(variantId, {
            ...existing,
            quantity: existing.quantity + quantity
          });
        } else {
          // Add new product to map
          productMap.set(variantId, {
            price: price,
            quantity: quantity
          });
        }
      }
    }
  });
  
  // Calculate total value and prepare product IDs array
  let totalValue = 0;
  const uniqueProductIds = [];
  
  productMap.forEach((details, variantId) => {
    uniqueProductIds.push(variantId);
    const productTotal = details.price * details.quantity;
    totalValue += productTotal;
  });
  
  // Send event to Google Ads
  if (uniqueProductIds.length > 0) {
    gtag('event', 'view_cart', {
      'ecomm_prodid': uniqueProductIds,
      'ecomm_pagetype': 'cart',
      'ecomm_totalvalue': totalValue,
      'currency': 'USD'
    });
  }
});